import { Stack, Text } from "@chakra-ui/react"

const LabelInfo = ({ title, children, size }) => {
    return (
        <Stack w="full" direction={{ base: "column", md: "row" }}>
            <Text fontWeight="bold" fontSize={size || "md"}>{title}</Text>
            <Text fontSize={size || "md"}>{children}</Text>
        </Stack>
    )
}

export default LabelInfo